import React from "react";
import * as styles from "./fancy-link.module.css";

const FancyLink = ({ href, target = null, children }) => {
  const isExternal = target === "_blank";

  return (
    <a
      href={href}
      className={styles.fancyLink}
      target={target}
      rel={isExternal ? "noopener noreferrer" : undefined}
    >
      <span>{children}</span>
      <span aria-hidden="true">{children}</span>
    </a>
  );
};

export default FancyLink;
